import Vue from 'vue';

const legacy = Vue.extend();

global.legacyComponent = legacy;

export default legacy;